import initialState from './initialState';
import { v4 as uuidv4 } from 'uuid';

export const SET_FIELD_DROP_END = (section, state, action) => {
  const { fields, fieldsIds, moduleId } = action.payload;
  return ({
    ...state,
    [section]: {
      ...state[section],
      dynamicForms: {
        ...state[section].dynamicForms,
        fields,
        modules: {
          ...state[section].dynamicForms.modules,
          [moduleId]: {
            ...state[section].dynamicForms.modules[moduleId],
            fieldsIds
          }
        }
      }
    }
  });
};

export const SET_MODULE_DROP_END = (section, state, action) => {
  const { modulesIds, sectionId } = action.payload;
  return ({
    ...state,
    [section]: {
      ...state[section],
      dynamicForms: {
        ...state[section].dynamicForms,
        sections: {
          ...state[section].dynamicForms.sections,
          [sectionId]: {
            ...state[section].dynamicForms.sections[sectionId],
            modulesIds
          }
        }
      }
    }
  });
};

export const SET_SECTION_DROP_END = (section, state, action) => {
  const { sectionsIds } = action.payload;
  return ({
    ...state,
    [section]: {
      ...state[section],
      dynamicForms: {
        ...state[section].dynamicForms,
        forms: {
          ...state[section].dynamicForms.forms,
          sectionsIds
        }
      }
    }
  });
};

export const CHANGE_INPUT_SECTIONS = (section, state, action) => {
  const { value, name, idSection } = action.payload;
  return ({
    ...state,
    [section]: {
      ...state[section],
      dynamicForms: {
        ...state[section].dynamicForms,
        sections: {
          ...state[section].dynamicForms.sections,
          [idSection]: {
            ...state[section].dynamicForms.sections[idSection],
            [name]: value
          }
        }
      }
    }
  });
};

export const CHANGE_INPUT_MODULES = (section, state, action) => {
  const { value, name, idModule } = action.payload;
  return ({
    ...state,
    [section]: {
      ...state[section],
      dynamicForms: {
        ...state[section].dynamicForms,
        modules: {
          ...state[section].dynamicForms.modules,
          [idModule]: {
            ...state[section].dynamicForms.modules[idModule],
            [name]: value
          }
        }
      }
    }
  });
};

export const CHANGE_INPUT_HEADER = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      dynamicForms: {
        ...state[section].dynamicForms,
        forms: {
          ...state[section].dynamicForms.forms,
          [action.payload.name]: action.payload.value
        }
      }
    }
  });
};

export const CHANGE_ATTACH_PATIENT_MODEL = (section, state, action) => {
  const { done } = action.payload;
  return ({
    ...state,
    [section]: {
      ...state[section],
      dynamicForms: {
        ...state[section].dynamicForms,
        forms: {
          ...state[section].dynamicForms.forms,
          attachPatientModel: done
        }
      }
    }
  });
};

export const GET_LIST_FIELDS_FETCH_REQUEST = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      fetching: {
        ...state[section].fetching,
        getListFields: true,
      }
    }
  });
};

export const GET_LIST_FIELDS_FETCH_SUCCESS = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      isFirstLoading: false,
      fetching: {
        ...state[section].fetching,
        getListFields: false,
      },
      api: {
        ...state[section].api,
        getListFields: action.payload.data
      },
      listFields: {
        ...state[section].listFields,
        ...action.payload.listFields,
        customIdsOriginal: action.payload.listFields.customIds
      }
    }
  });
};

export const GET_LIST_FIELDS_MANAGER_FETCH_SUCCESS = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      isFirstLoading: false,
      fetching: {
        ...state[section].fetching,
        getListFields: false,
      },
      api: {
        ...state[section].api,
        getListFieldsManager: action.payload.data
      },
      listFields: {
        ...state[section].listFields,
        items: {
          ...state[section].listFields.items,
          ...action.payload.listFields.items
        },
        managerIds: action.payload.listFields.managerIds,
        managerIdsOriginal: action.payload.listFields.managerIds
      }
    }
  });
};

export const GET_LIST_FIELDS_FETCH_ERROR = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      fetching: {
        ...state[section].fetching,
        getListFields: false,
      }
    }
  });
};

export const SET_SEARCH_FIELDS_TAB = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      listFields: {
        ...state[section].listFields,
        customIds: action.payload.customIds
      }
    }
  });
};

export const SET_SEARCH_FIELDS_MANAGER_TAB = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      listFields: {
        ...state[section].listFields,
        managerIds: action.payload.managerIds
      }
    }
  });
};

export const RESET_DYNAMIC_FORMS = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      dynamicForms: {
        fields: {},
        modules: {},
        sections: {},
        forms: {
          idForm: '',
          name: '',
          description: '',
          attachPatientModel: false,
          sectionsIds: []
        }
      }
    }
  });
};

export const SET_NEW_SECTION = (section, state, action) => {
  const { sections, sectionsIds } = action.payload;
  return ({
    ...state,
    [section]: {
      ...state[section],
      dynamicForms: {
        ...state[section].dynamicForms,
        sections,
        forms: {
          ...state[section].dynamicForms.forms,
          sectionsIds: [...sectionsIds]
        }
      }
    }
  });
};

export const SET_NEW_MODULES = (section, state, action) => {
  const { modules, modulesIds, idSection } = action.payload;
  return ({
    ...state,
    [section]: {
      ...state[section],
      dynamicForms: {
        ...state[section].dynamicForms,
        modules,
        sections: {
          ...state[section].dynamicForms.sections,
          [idSection]: {
            ...state[section].dynamicForms.sections[idSection],
            modulesIds
          }
        }
      }
    }
  });
};

export const SET_NEW_FIELDS_IDS = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      listFields: {
        ...state[section].listFields,
        customIds: action.payload.newFieldsIds
      }
    }
  });
};

export const SET_NEW_DYNAMIC_FIELDS = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      dynamicForms: {
        ...state[section].dynamicForms,
        modules: {
          ...state[section].dynamicForms.modules,
          [action.payload.moduleId]: {
            ...state[section].dynamicForms.modules[action.payload.moduleId],
            fieldsIds: action.payload.moduleFields
          }
        },
        fields: action.payload.newFieldsObj
      }
    }
  });
};

export const GET_MODEL_BY_ID_FETCH_REQUEST = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      fetching: {
        ...state[section].fetching,
        getModelById: true,
      }
    }
  });
};

export const GET_MODEL_BY_ID_FETCH_SUCCESS = (section, state, action) => {
  const { idField, result } = action.payload;
  return ({
    ...state,
    [section]: {
      ...state[section],
      fetching: {
        ...state[section].fetching,
        getModelById: false,
      },
      dynamicForms: {
        ...state[section].dynamicForms,
        fields: {
          ...state[section].dynamicForms.fields,
          [idField]: {
            ...state[section].dynamicForms.fields[idField],
            ...result,
            perfomSearch: false
          }
        }
      }
    }
  });
};

export const GET_MODEL_BY_ID_FETCH_ERROR = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      fetching: {
        ...state[section].fetching,
        getModelById: false,
      }
    }
  });
};

export const REMOVED_FIELD = (section, state, action) => {
  const { fields, fieldsIds, idModule } = action.payload;
  return ({
    ...state,
    [section]: {
      ...state[section],
      dynamicForms: {
        ...state[section].dynamicForms,
        fields,
        modules: {
          ...state[section].dynamicForms.modules,
          [idModule]: {
            ...state[section].dynamicForms.modules[idModule],
            fieldsIds
          }
        }
      }
    }
  });
};

export const REMOVED_MODULE = (section, state, action) => {
  const { fields, modules, modulesIds, idSection } = action.payload;
  return ({
    ...state,
    [section]: {
      ...state[section],
      dynamicForms: {
        ...state[section].dynamicForms,
        fields,
        modules,
        sections: {
          ...state[section].dynamicForms.sections,
          [idSection]: {
            ...state[section].dynamicForms.sections[idSection],
            modulesIds: [...modulesIds]
          }
        }
      }
    }
  });
};

export const REMOVED_SECTION = (section, state, action) => {
  const { sections, sectionsIds, modules, fields } = action.payload;
  return ({
    ...state,
    [section]: {
      ...state[section],
      dynamicForms: {
        ...state[section].dynamicForms,
        fields,
        modules,
        sections,
        forms: {
          ...state[section].dynamicForms.forms,
          sectionsIds: [...sectionsIds]
        }
      }
    }
  });
};

export const MODAL_OPEN_VISIBILE = (section, state, action) => {
  const { idModal, idField, field } = action.payload;
  return ({
    ...state,
    [section]: {
      ...state[section],
      modal: {
        ...state[section].modal,
        [idModal]: {
          ...state[section].modal[idModal],
          visible: true,
          titleFieldId: idField,
          field: {
            ...state[section].modal[idModal].field,
            [idField]: {
              ...field
            }
          }
        }
      }
    }
  });
};

export const MODAL_CLOSE_VISIBILE = (section, state, action) => {
  // const {idModal} = action.payload;
  return ({
    ...state,
    [section]: {
      ...state[section],
      modal: {
        ...initialState.modal,
      }
    }
  });
};

export const MODAL_CHANGE_INPUT = (section, state, action) => {
  const { field, idField, idModal } = action.payload;
  return ({
    ...state,
    [section]: {
      ...state[section],
      modal: {
        ...state[section].modal,
        [idModal]: {
          ...state[section].modal[idModal],
          field: {
            ...state[section].modal[idModal].field,
            [idField]: field
          }
        }
      }
    }
  });
};

export const MODAL_CHANGE_INPUT_SIZE = (section, state, action) => {
  const { field, idModal, idField } = action.payload;
  return ({
    ...state,
    [section]: {
      ...state[section],
      modal: {
        ...state[section].modal,
        [idModal]: {
          ...state[section].modal[idModal],
          field: {
            ...state[section].modal[idModal].field,
            [idField]: field
          }
        }
      }
    }
  });
};

export const MODAL_SAVE_FIELD = (section, state, action) => {
  const { field, idField } = action.payload;
  return ({
    ...state,
    [section]: {
      ...state[section],
      dynamicForms: {
        ...state[section].dynamicForms,
        fields: {
          ...state[section].dynamicForms.fields,
          [idField]: {
            ...state[section].dynamicForms.fields[idField],
            ...field
          }
        }
      }
    }
  });
};

export const SAVE_VERSION_FIELD_FETCH_REQUEST = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      fetching: {
        ...state[section].fetching,
        saveVersionField: true,
      }
    }
  });
};

export const SAVE_VERSION_FIELD_FETCH_SUCCESS = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      fetching: {
        ...state[section].fetching,
        saveVersionField: false,
      }
    }
  });
};

export const SAVE_VERSION_FIELD_FETCH_ERROR = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      fetching: {
        ...state[section].fetching,
        saveVersionField: false,
      }
    }
  });
};

export const SET_FIELD_MODEL_VERSION = (section, state, action) => {
  const { items, fields } = action.payload;
  return ({
    ...state,
    [section]: {
      ...state[section],
      listFields: {
        ...state[section].listFields,
        items
      },
      dynamicForms: {
        ...state[section].dynamicForms,
        fields
      }
    }
  });
};

export const SAVE_FETCH_REQUEST = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      fetching: {
        ...state[section].fetching,
        saveForm: true,
      }
    }
  });
};

export const SAVE_FETCH_SUCCESS = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      fetching: {
        ...state[section].fetching,
        saveForm: false,
      }
    }
  });
};

export const SAVE_FETCH_ERROR = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      fetching: {
        ...state[section].fetching,
        saveForm: false,
      },
      error: {
        ...state[section].error,
        done: true
      }
    }
  });
};

export const GET_DRAFT_BY_ID_FETCH_REQUEST = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      fetching: {
        ...state[section].fetching,
        getDraftById: true,
      }
    }
  });
};

export const GET_DRAFT_BY_ID_FETCH_SUCCESS = (section, state, action) => {
  const { draftId, formOrigin, hideAttachPatientModel } = action.payload;

  return ({
    ...state,
    [section]: {
      ...state[section],
      hideAttachPatientModel,
      formOrigin,
      fetching: {
        ...state[section].fetching,
        getDraftById: false,
      },
      dynamicForms: {
        ...state[section].dynamicForms,
        draftId,
        forms: {
          ...state[section].dynamicForms.forms,
          attachPatientModel: hideAttachPatientModel
        }
      }
    }
  });
};

export const GET_DRAFT_BY_ID_FETCH_ERROR = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      fetching: {
        ...state[section].fetching,
        getDraftById: false,
      }
    }
  });
};

export const SAVE_DRAFT_FETCH_REQUEST = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      fetching: {
        ...state[section].fetching,
        saveDraft: true,
      }
    }
  });
};

export const SAVE_DRAFT_FETCH_SUCCESS = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      fetching: {
        ...state[section].fetching,
        saveDraft: false,
      }
    }
  });
};

export const SAVE_DRAFT_FETCH_ERROR = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      fetching: {
        ...state[section].fetching,
        saveDraft: false,
      }
    }
  });
};

export const SET_BUILD_DRAFT_BY_ID = (section, state, action) => {
  const { draftId, fields, modules, sections, forms, configForm } = action.payload;
  return ({
    ...state,
    [section]: {
      ...state[section],
      dynamicForms: {
        ...state[section].dynamicForms,
        draftId,
        fields,
        modules,
        sections,
        forms: {
          ...state[section].dynamicForms.forms,
          ...forms
        }
      },
      formBuilderChat: initialState.formBuilderChat,
      configForm
    }
  });
};

export const SET_UPDATE_FIELD_BY_ID = (section, state, action) => {
  const { idField, field } = action.payload;
  return ({
    ...state,
    [section]: {
      ...state[section],
      dynamicForms: {
        ...state[section].dynamicForms,
        fields: {
          ...state[section].dynamicForms.fields,
          [idField]: {
            ...state[section].dynamicForms.fields[idField],
            ...field
          }
        }
      }
    }
  });
};

export const CHANGE_INPUT_DATA_FORM = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      dynamicForms: {
        ...state[section].dynamicForms,
        forms: {
          ...state[section].dynamicForms.forms,
          [action.payload.name]: action.payload.value
        }
      }
    }
  });
};

export const MODALFIELDS_SET_CONFIG_FIELD = (section, state, action) => {
  const { fieldModelId, fieldConfig } = action.payload;

  return ({
    ...state,
    [section]: {
      ...state[section],
      configForm: {
        ...state[section].configForm,
        [fieldModelId]: {
          ...fieldConfig
        }
      }
    }
  });
};

export const FORMS_CREATE_UPDATE_CONFIG_FORM_FETCH_REQUEST = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      fetching: {
        ...state[section].fetching,
        updateConfigForm: true,
      }
    }
  });
};

export const FORMS_CREATE_UPDATE_CONFIG_FORM_FETCH_SUCCESS = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      fetching: {
        ...state[section].fetching,
        updateConfigForm: false,
      }
    }
  });
};

export const FORMS_CREATE_UPDATE_CONFIG_FORM_FETCH_ERROR = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      fetching: {
        ...state[section].fetching,
        updateConfigForm: false,
      }
    }
  });
};

export const FORMS_CREATE_GET_IMAGE_FORM_FIELD_SAVED_FETCH_SUCCESS = (section, state, action) => {
  const { fileReference, base64url } = action.payload;

  return ({
    ...state,
    [section]: {
      ...state[section],
      imagesField: {
        ...state[section].imagesField,
        [fileReference]: base64url,
      }
    }
  });
};

export const FORMS_CREATE_UPLOAD_DOCUMENT_FETCH_REQUEST = (section, state, action) => {
  const { fileId } = action.payload;

  return ({
    ...state,
    [section]: {
      ...state[section],
      fetching: {
        ...state[section].fetching,
        uploadDocument: true,
      },
      uploadedDocuments: {
        ...state[section].uploadedDocuments,
        [fileId]: {
          ...state[section].uploadedDocuments[fileId],
          status: 'uploading',
          progress: 0,
          error: null,
        }
      }
    }
  });
};

export const FORMS_CREATE_UPLOAD_DOCUMENT_FETCH_SUCCESS = (section, state, action) => {
  const { fileId, uploadData } = action.payload;

  return ({
    ...state,
    [section]: {
      ...state[section],
      fetching: {
        ...state[section].fetching,
        uploadDocument: false,
        isSaveBlock: true,
      },
      uploadedDocuments: {
        ...state[section].uploadedDocuments,
        [fileId]: {
          ...state[section].uploadedDocuments[fileId],
          status: 'uploaded',
          progress: 100,
          uploadData,
          error: null,
        }
      }
    }
  });
};

export const FORMS_CREATE_UPLOAD_DOCUMENT_FETCH_ERROR = (section, state, action) => {
  const { fileId, error } = action.payload;

  return ({
    ...state,
    [section]: {
      ...state[section],
      fetching: {
        ...state[section].fetching,
        uploadDocument: false,
      },
      uploadedDocuments: {
        ...state[section].uploadedDocuments,
        [fileId]: {
          ...state[section].uploadedDocuments[fileId],
          status: 'error',
          error,
        }
      }
    }
  });
};

export const FORMS_CREATE_UPLOAD_DOCUMENT_PROGRESS = (section, state, action) => {
  const { fileId, progress } = action.payload;

  return ({
    ...state,
    [section]: {
      ...state[section],
      uploadedDocuments: {
        ...state[section].uploadedDocuments,
        [fileId]: {
          ...state[section].uploadedDocuments[fileId],
          progress,
        }
      }
    }
  });
};

export const FORMS_CREATE_EXTRACT_TEXT_FETCH_REQUEST = (section, state, action) => {
  const { fileId } = action.payload;

  return ({
    ...state,
    [section]: {
      ...state[section],
      fetching: {
        ...state[section].fetching,
        extractText: true,
      },
      uploadedDocuments: {
        ...state[section].uploadedDocuments,
        [fileId]: {
          ...state[section].uploadedDocuments[fileId],
          extractionStatus: 'extracting',
          extractionError: null,
        }
      }
    }
  });
};

export const FORMS_CREATE_EXTRACT_TEXT_FETCH_SUCCESS = (section, state, action) => {
  const { fileId, extractedData, uploadData } = action.payload;

  return ({
    ...state,
    [section]: {
      ...state[section],
      fetching: {
        ...state[section].fetching,
        extractText: false,
      },
      uploadedDocuments: {
        ...state[section].uploadedDocuments,
        [fileId]: {
          ...state[section].uploadedDocuments[fileId],
          extractionStatus: 'completed',
          extractedData,
          extractionError: null,
        }
      }
    }
  });
};

export const FORMS_CREATE_EXTRACT_TEXT_FETCH_ERROR = (section, state, action) => {
  const { fileId, error } = action.payload;

  return ({
    ...state,
    [section]: {
      ...state[section],
      fetching: {
        ...state[section].fetching,
        extractText: false,
      },
      uploadedDocuments: {
        ...state[section].uploadedDocuments,
        [fileId]: {
          ...state[section].uploadedDocuments[fileId],
          extractionStatus: 'error',
          extractionError: error,
        }
      }
    }
  });
};

// Job Stream Reducers
export const FORMS_CREATE_JOB_STREAM_CONNECTED = (section, state, action) => {
  const { jobId, fileId } = action.payload;

  return ({
    ...state,
    [section]: {
      ...state[section],
      activeJobs: {
        ...state[section].activeJobs,
        [jobId]: {
          jobId,
          fileId,
          status: 'connected',
          progress: 0,
          step: '',
          logs: [],
          pendingAction: null,
          connectedAt: new Date().toISOString()
        }
      },
      jobStreams: {
        ...state[section].jobStreams,
        [jobId]: {
          connected: true,
          error: null
        }
      }
    }
  });
};

export const FORMS_CREATE_JOB_STREAM_UPDATE = (section, state, action) => {
  const { jobId, data } = action.payload;

  return ({
    ...state,
    [section]: {
      ...state[section],
      activeJobs: {
        ...state[section].activeJobs,
        [jobId]: {
          ...state[section].activeJobs[jobId],
          status: data.status,
          error: data.error,
          progress: data.progress,
          step: data.step || (data.progress !== 100 ? state[section].activeJobs[jobId]?.step || '' : ''),
          logs: data.logs || state[section].activeJobs[jobId]?.logs || [],
          pendingAction: data.pendingAction,
          updatedAt: new Date().toISOString()
        }
      },
      uploadedDocuments: {
        ...state[section].uploadedDocuments,
        [state[section].activeJobs[jobId]?.fileId]: {
          ...state[section].uploadedDocuments[state[section].activeJobs[jobId]?.fileId],
          jobProgress: data.progress,
          jobStep: data.step,
          jobStatus: data.status,
          jobLogs: data.logs
        }
      }
    }
  });
};

export const FORMS_CREATE_JOB_STREAM_ERROR = (section, state, action) => {
  const { jobId, error } = action.payload;

  return ({
    ...state,
    [section]: {
      ...state[section],
      jobStreams: {
        ...state[section].jobStreams,
        [jobId]: {
          ...state[section].jobStreams[jobId],
          connected: false,
          error: error
        }
      }
    }
  });
};

export const FORMS_CREATE_JOB_STREAM_CLOSED = (section, state, action) => {
  const { jobId } = action.payload;

  const newJobStreams = { ...state[section].jobStreams };
  delete newJobStreams[jobId];

  return ({
    ...state,
    [section]: {
      ...state[section],
      jobStreams: newJobStreams
    }
  });
};

export const FORMS_CREATE_PROCESS_EXTRACTED_FORM_DATA = (section, state, action) => {
  const { formData } = action.payload;
  const { structure, fields: extractedFields, resultPartial } = formData;

  const fields = {};
  const fieldsIdsByNames = {};

  extractedFields.forEach((field) => {
    const fieldId = field.fieldId || uuidv4();
    fieldsIdsByNames[field.name] = fieldId;
    fields[fieldId] = {
      ...field,
      fieldId,
      id: fieldId,
      fieldModelId: field.fieldModelId,
      fieldModelVersionId: field.fieldModelVersionId,
      resultPartial,
      fieldName: field.name,
      fieldName: field.displayName || field.name,
      displayName: field.displayName,
      title: field.name,
      name: field.name,
      dataType: field.dataType,
      unit: field.unit || '',
      unitDisplay: field.unitDisplay || '',
      scaleConfig: field.scaleConfig || {},
      radioGroup: field.radioGroup || null,
      calculation: field.calculation || null,
      qualifierResultado: field.qualifierResultado || null,
      isQualifierDeficiencia: field.isQualifierDeficiencia || false,
      isNew: true,
      order: 0,
      similarityScore: field.similarityScore,
      similarFieldId: field.similarFieldId,
      code: field.code || '',
      codeConfig: field.codeConfig || null,
      fieldsIds: field.fields || [],
    };
  });

  const modules = {};
  const sections = {};
  const sectionsIds = [];

  if (structure.sections && structure.sections.length > 0) {
    structure.sections.forEach((section, sectionIndex) => {
      const sectionId = section.sectionId || `section-${sectionIndex + 1}`;
      sectionsIds.push(sectionId);

      const modulesIds = [];

      if (section.modules && section.modules.length > 0) {
        section.modules.forEach((module, moduleIndex) => {
          const moduleId = module.moduleId || `module-${moduleIndex + 1}`;
          modulesIds.push(moduleId);

          const fieldsIds = (module.fields || []).map(field => fieldsIdsByNames[field]);

          modules[moduleId] = {
            id: moduleId,
            name: module.moduleName || `Module ${moduleIndex + 1}`,
            description: '',
            fieldsIds: fieldsIds
          };
        });
      }

      sections[sectionId] = {
        id: sectionId,
        name: section.sectionName || `Section ${sectionIndex + 1}`,
        description: '',
        modulesIds: modulesIds
      };
    });
  }

  const forms = {
    idForm: structure.formName || '',
    name: structure.formTitle || '',
    description: `${structure.acronym || ''} - Version ${structure.version || ''}`.trim(),
    attachPatientModel: false,
    sectionsIds: sectionsIds,
    metadata: structure.metadata || {}
  };

  return ({
    ...state,
    [section]: {
      ...state[section],
      dynamicForms: {
        ...state[section].dynamicForms,
        fields,
        modules,
        sections,
        forms
      }
    }
  });
};

export const FORMS_CREATE_CHANGE_IS_BLOCK_SAVE = (section, state, action) => {
  const { data } = action.payload;
  return ({
    ...state,
    [section]: {
      ...state[section],
      fetching: { ...state[section].fetching, isSaveBlock: data }
    }
  });
};

export const FORMS_CREATE_GET_FIELDS_LAST_VERSION_BY_FIELD_MODEL_IDS_FETCH_SUCCESS = (section, state, action) => {
  const fields = {};
  action.payload.forEach(field => {
    fields[field.fieldModelId] = field;
  });

  return ({
    ...state,
    [section]: {
      ...state[section],
      fieldsSimilar: fields
    }
  });
};

export const FORMS_CREATE_REPLACE_BY_SIMILAR_FIELD_FETCH_SUCCESS = (section, state, action) => {
  const { fieldId, field } = action.payload;
  return ({
    ...state,
    [section]: {
      ...state[section],
      dynamicForms: {
        ...state[section].dynamicForms,
        fields: {
          ...state[section].dynamicForms.fields,
          [fieldId]: field
        }
      }
    }
  });
};

// FormBuilder Chat Reducers
export const FORMBUILDER_CHAT_CREATE_SESSION_REQUEST = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      formBuilderChat: {
        ...state[section].formBuilderChat,
        fetching: {
          ...state[section].formBuilderChat.fetching,
          createSession: true
        }
      }
    }
  });
};

export const FORMBUILDER_CHAT_CREATE_SESSION_SUCCESS = (section, state, action) => {
  const { sessionId, response, session } = action.payload;

  return ({
    ...state,
    [section]: {
      ...state[section],
      formBuilderChat: {
        ...state[section].formBuilderChat,
        sessionId: sessionId,
        formName: session?.formName || '',
        messages: response?.message ? [{ role: 'assistant', message: response.message, timestamp: new Date().toISOString() }] : [],
        currentForm: response?.form || null,
        stats: response?.stats || { totalFields: 0, totalMessages: 1 },
        fetching: {
          ...state[section].formBuilderChat.fetching,
          createSession: false
        }
      }
    }
  });
};

export const FORMBUILDER_CHAT_CREATE_SESSION_FAILURE = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      formBuilderChat: {
        ...state[section].formBuilderChat,
        fetching: {
          ...state[section].formBuilderChat.fetching,
          createSession: false
        }
      }
    }
  });
};

export const FORMBUILDER_CHAT_SEND_MESSAGE_REQUEST = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      formBuilderChat: {
        ...state[section].formBuilderChat,
        fetching: {
          ...state[section].formBuilderChat.fetching,
          sendMessage: true
        }
      }
    }
  });
};

export const FORMBUILDER_CHAT_SEND_MESSAGE_SUCCESS = (section, state, action) => {
  const { sessionId, websocketUrl } = action.payload || {};

  return ({
    ...state,
    [section]: {
      ...state[section],
      fetching: {
        ...state[section].fetching,
        isSaveBlock: true
      },
      formBuilderChat: {
        ...state[section].formBuilderChat,
        ...(sessionId && { sessionId }),
        fetching: {
          ...state[section].formBuilderChat.fetching,
          sendMessage: false
        },
        finishFormChat: false,
      }
    }
  });
};

export const FORMBUILDER_CHAT_SEND_MESSAGE_FAILURE = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      formBuilderChat: {
        ...state[section].formBuilderChat,
        fetching: {
          ...state[section].formBuilderChat.fetching,
          sendMessage: false
        }
      }
    }
  });
};

export const FORMBUILDER_CHAT_FINISH_SESSION_REQUEST = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      formBuilderChat: {
        ...state[section].formBuilderChat,
        fetching: {
          ...state[section].formBuilderChat.fetching,
          finishSession: true
        }
      }
    }
  });
};

export const FORMBUILDER_CHAT_FINISH_SESSION_SUCCESS = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      fetching: {
        ...state[section].fetching,
        isSaveBlock: false
      },
      formBuilderChat: {
        ...state[section].formBuilderChat,
        finalForm: action.payload,
        finishFormChat: true,
        sessionId: null,
        websocketUrl: null
      }
    }
  });
};

export const FORMBUILDER_CHAT_FINISH_SESSION_FAILURE = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      formBuilderChat: {
        ...state[section].formBuilderChat,
        fetching: {
          ...state[section].formBuilderChat.fetching,
          finishSession: false
        }
      }
    }
  });
};

export const FORMBUILDER_CHAT_LIST_SESSIONS_REQUEST = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      formBuilderChat: {
        ...state[section].formBuilderChat,
        fetching: {
          ...state[section].formBuilderChat.fetching,
          listSessions: true
        }
      }
    }
  });
};

export const FORMBUILDER_CHAT_LIST_SESSIONS_SUCCESS = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      formBuilderChat: {
        ...state[section].formBuilderChat,
        sessions: action.payload || [],
        fetching: {
          ...state[section].formBuilderChat.fetching,
          listSessions: false
        }
      }
    }
  });
};

export const FORMBUILDER_CHAT_LIST_SESSIONS_FAILURE = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      formBuilderChat: {
        ...state[section].formBuilderChat,
        fetching: {
          ...state[section].formBuilderChat.fetching,
          listSessions: false
        }
      }
    }
  });
};

export const FORMBUILDER_CHAT_GET_SESSION_REQUEST = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      formBuilderChat: {
        ...state[section].formBuilderChat,
        fetching: {
          ...state[section].formBuilderChat.fetching,
          getSession: true
        }
      }
    }
  });
};

export const FORMBUILDER_CHAT_GET_SESSION_SUCCESS = (section, state, action) => {
  const { sessionId, formName, messages, currentForm, stats } = action.payload;

  return ({
    ...state,
    [section]: {
      ...state[section],
      formBuilderChat: {
        ...state[section].formBuilderChat,
        sessionId,
        formName,
        messages: messages || [],
        currentForm,
        stats: stats || { totalFields: 0, totalMessages: messages?.length || 0 },
        fetching: {
          ...state[section].formBuilderChat.fetching,
          getSession: false
        }
      }
    }
  });
};

export const FORMBUILDER_CHAT_GET_SESSION_FAILURE = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      formBuilderChat: {
        ...state[section].formBuilderChat,
        fetching: {
          ...state[section].formBuilderChat.fetching,
          getSession: false
        }
      }
    }
  });
};

export const FORMBUILDER_CHAT_ADD_MESSAGE = (section, state, action) => {
  const newMessage = action.payload;

  return ({
    ...state,
    [section]: {
      ...state[section],
      formBuilderChat: {
        ...state[section].formBuilderChat,
        isInitialized: true,
        messages: [...state[section].formBuilderChat.messages, newMessage]
      }
    }
  });
};

export const FORMBUILDER_CHAT_UPDATE_FORM_PREVIEW = (section, state, action) => {
  const { form, stats } = action.payload;

  return ({
    ...state,
    [section]: {
      ...state[section],
      formBuilderChat: {
        ...state[section].formBuilderChat,
        stats: stats || state[section].formBuilderChat.stats
      }
    }
  });
};

export const FORMBUILDER_CHAT_SET_TYPING = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      formBuilderChat: {
        ...state[section].formBuilderChat,
        isTyping: action.payload
      }
    }
  });
};

export const FORMBUILDER_CHAT_WEBSOCKET_CONNECTED = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      formBuilderChat: {
        ...state[section].formBuilderChat,
        websocketConnected: action.payload
      }
    }
  });
};

export const FORMBUILDER_CHAT_WEBSOCKET_DISCONNECTED = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      formBuilderChat: {
        ...state[section].formBuilderChat,
        websocketConnected: false
      }
    }
  });
};

export const FORMBUILDER_CHAT_RESET = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      formBuilderChat: {
        sessionId: null,
        formName: '',
        messages: [],
        currentForm: null,
        stats: { totalFields: 0, totalMessages: 0 },
        isTyping: false,
        websocketConnected: false,
        sessions: [],
        finalForm: null,
        backupForm: null,
        fetching: {
          createSession: false,
          sendMessage: false,
          finishSession: false,
          listSessions: false,
          getSession: false
        }
      }
    }
  });
};

export const FORMBUILDER_CHAT_BACKUP_FORM = (section, state, action) => {
  return ({
    ...state,
    [section]: {
      ...state[section],
      formBuilderChat: {
        ...state[section].formBuilderChat,
        backupForm: action.payload
      }
    }
  });
};

export const FORMBUILDER_CHAT_RESTORE_FORM = (section, state, action) => {
  const { fields, modules, sections, form } = action.payload;

  return ({
    ...state,
    [section]: {
      ...state[section],
      dynamicForms: {
        ...state[section].dynamicForms,
        fields,
        modules,
        sections,
        forms: form
      }
    }
  });
};